import { filter } from 'core-js/internals/array-iteration'

const selectors = {
  taxonomy: '[data-taxonomy]',
  filter: '[data-filter]',

  accordion: '[data-faq-accordion]',
  accordionHeader: '[data-faq-accordion-header]',

  active: 'active',
  hidden: 'hidden',
}

const initFAQOverviewFilters = (params) => {
  const faqItems = document.querySelectorAll(selectors.taxonomy)
  const filters = document.querySelectorAll(selectors.filter)

  if (!filters.length) return

  const activeCategoryIndex = [...filters].findIndex((filter) => filter.dataset.filter === params.category)

  const setActiveTaxonomy = (filter) => {
    params.category = filter.dataset.filter

    window.history.replaceState(null, null, `?category=${filter.dataset.filter}&question=${params.question}`)

    filters.forEach((filter) => {
      filter.classList.remove(selectors.active)
      filter.setAttribute('aria-selected', 'false')
    })

    faqItems.forEach((faq) => {
      if (faq.dataset.taxonomy !== filter.dataset.filter) {
        faq.classList.add(selectors.hidden)
        faq.setAttribute('aria-hidden', 'true')
        return
      }

      faq.classList.remove(selectors.hidden)
      faq.setAttribute('aria-hidden', 'false')
    })

    filter.classList.add(selectors.active)
    filter.setAttribute('aria-selected', 'true')
  }

  filters.forEach((filter) => filter.addEventListener('click', () => setActiveTaxonomy(filter)))

  setActiveTaxonomy(filters[activeCategoryIndex] || filters[0])
}

const initAccordions = (params) => {
  const accordions = document.querySelectorAll(selectors.accordion)

  accordions?.forEach((accordion) => {
    const header = accordion.querySelector(selectors.accordionHeader)
    const isActive = window.location.href.includes(accordion.dataset.faq)

    if (isActive) {
      accordion.classList.add(selectors.active)
      header.setAttribute('aria-expanded', 'true')
    }

    header?.addEventListener('click', () => {
      window.history.replaceState(null, null, `?category=${params.category}&question=${accordion.dataset.faq}`)

      header.setAttribute('aria-expanded', accordion.classList.contains(selectors.active) ? 'false' : 'true')
      accordion.classList.toggle(selectors.active)
    })
  })
}

const initFAQOverview = () => {
  const urlParams = new URLSearchParams(window.location.search)
  let params = { category: urlParams.get('category'), question: urlParams.get('question') }

  initFAQOverviewFilters(params)
  initAccordions(params)
}

export default initFAQOverview
